import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import Payout from '../components/pressroomLayout';
import { removeTrailingSlash } from '../utils/gatsby-node-helpers';

const TipOfTheDay = () => {
    const data = useStaticQuery(graphql`
        query {
            allWpTip(sort: { date: DESC }) {
                edges {
                    node {
                        title
                        date(formatString: "MMMM DD, YYYY")
                        databaseId
                        uri
                    }
                }
            }
        }
    `);

    return (
        <Payout>
            {data.allWpTip.edges.map(({ node }) => {
                let link = `/tip-of-the-day` + decodeURI(node.uri);
                link = removeTrailingSlash(link);
                return (
                    <div className="col-12 p-0 m-0" key={node.databaseId}>
                        <Link id={node.uri} className="text-decoration-none" to={link}>
                            <h4 className="h5 text-body" dangerouslySetInnerHTML={{ __html: node.title }} />
                        </Link>
                        <div className="text-muted d-block mb-4">{node.date}</div>
                    </div>
                );
            })}
        </Payout>
    );
};

export default TipOfTheDay;
